import { type } from "./actionTypes"

const initialState = {
  saveSatutoryReport: {},
}

const SatutoryReport = (state = initialState, action) => {
  switch (action.type) {
    case type.SAVE_SATUTORY_REPORT:
      console.log("action.data", action.payload.value)
      let facId = action.payload.value.facId
      let date = action.payload.value.date

      return {
        ...state,
        saveSatutoryReport: {
          ...state.saveSatutoryReport,
          [facId]: {
            ...state.saveSatutoryReport[facId],
            [date]: action.payload.value,
          },
        },
      }
    case type.REMOVE_SAVE_SATUTORY_REPORT: {
      const { facId: rFacId, date: rDate } = action.payload.value
      const existing = state.saveSatutoryReport[rFacId]
      if (!existing) return state
      const { [rDate]: _removed, ...restForFac } = existing
      return {
        ...state,
        saveSatutoryReport: {
          ...state.saveSatutoryReport,
          [rFacId]: restForFac,
        },
      }
    }
    default:
      return state
  }
}

export default SatutoryReport
